import { apiPost } from "./apiClient";
import { createCachedFetcher } from "./cachedFetcher";

// Single generic access point for the `uzd_misc` key-value store — one POST
// route parameterized by `mode`, backing ~9 unrelated lookups across the
// feature (part_condition_origin, part_side, query_source,
// order_cancel_reasons, unavailable_quickreply, billing_details_quick_reply,
// wati_channel_assignments, chat_settings, ...).
// Domain models shape the raw value per mode; this layer only fetches/caches
// it.
const fetchRaw = createCachedFetcher(
  mode => apiPost("/whatsapp/get_misc_mode", { mode }).then(res => {
    const payload = res.data;

    // The endpoint uses a response envelope. Preserve legitimate object-mode
    // values, but never pass/cache an authentication or API failure envelope
    // as though it were misc configuration data. Checking for the property
    // explicitly also keeps a successful `data: null` response as null rather
    // than falling back to the whole envelope.
    if (payload && typeof payload === "object" && Object.prototype.hasOwnProperty.call(payload, "data")) {
      return payload.success === false ? null : payload.data;
    }

    return payload;
  }),
);

export function fetchMiscMode(mode, { force = false } = {}) {
  return fetchRaw(mode, { force });
}

export function saveMiscMode(mode, moredetails) {
  return apiPost("/whatsapp/save_misc_mode", { mode, moredetails }).then(res => res.data);
}
